<template>
  <div v-if="currentToast" class="global-toasts">
    <Toast
      class="toast"
      :variant="currentToast.variant"
      :timeout="currentToast.timeout"
      :dismissible="currentToast.dismissible"
      :hide-icon="currentToast.hideIcon"
      @dismiss="removeToast"
      >{{ $t(currentToast.text) }}</Toast
    >
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import Toast from 'src/app/components/toast/Toast.vue';
import { useToastsStore } from 'commons/stores/toasts';

export default {
  name: 'GlobalToasts',
  components: {
    Toast,
  },
  computed: {
    ...mapState(useToastsStore, ['currentToast']),
  },
  methods: {
    ...mapActions(useToastsStore, ['removeToast']),
  },
};
</script>

<style lang="scss" scoped>
.global-toasts {
  position: absolute;
  bottom: 0;
  left: 24px;
  height: auto !important;
  right: 24px;
  z-index: 1061;
  padding-bottom: 24px;
}

.toast {
  margin: 0;
}
</style>
